import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CdsInputField, CdsDropdownField, useFormContext, CdsCheckboxField } from "clayco-component-library";
import { useContactStore } from "../../../store/contact";
import { useMsal } from "@azure/msal-react";
import ApiProvider from "../../../apiProvider";
import PhoneControl from "./phoneControl";
import { set } from "date-fns";

const ContactModalForm = ({
    data,
    countries,
    relationships,
    setPrimary,
    update
}) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const { setValue } = useFormContext();
    const { setStates, states } = useContactStore();
    const [selectedStates, setSelectedStates] = useState([])
    const [countryId, setCountryId] = useState(null);
    var funny = false;

    useEffect(()=>{
        if (!countryId)
            return; 

        var state = states?.find((state) => state.countryId === parseInt(countryId))
        if(!state)
            getStates(countryId)
        else{ 
            setSelectedStates(state.states)
        }
    },[states, countryId])

    useEffect(()=> {
        if (selectedStates && selectedStates.length > 0){
            if (!funny){
                setValue("state", data?.state);
                funny = true;
            }
        }
    }, [selectedStates])

    useEffect(() => {
        if(data){
            setValue('firstName', data.firstName)
            setValue('lastName', data.lastName)
            setValue('phoneNumber', data.phoneNumber)
            setValue('relationship', data.relationship)
            setValue('areaCode', data?.areaCode)
            setValue('isPrimary', data?.isPrimary)
            setValue('address1', data.addressLine1)
            setValue('address2', data.addressLine2)
            setValue('country', data.country)
            setValue('city', data.city)
            setValue('postalCode', data.postalCode)
            setCountryId(getCountryByCode(data?.country));
            setValue('state', data.state)
        }
    }, [data, setValue]);

    async function getStates(countryId) {
        let result = await apiProvider.Get(
            `Fields/States/${countryId}`,
            null,
            "application/json",
            false
        );
        if (result && !result.error && result !== "" && result.length !== 0) {
            setStates(countryId , result.map((i) => ({
                index: i.stateId,
                name: i.stateName,
                ...i
            })));
        }
    }

    function getCountryByCode(countryCode) {
        let found = countries.find((country)=> country.countryCode === countryCode)

        return found?.countryId;
    }
    
    function onCountryChanged(countryCode) {
        const contryIdInt = getCountryByCode(countryCode);
        setCountryId(contryIdInt);
        if(countries.find((country) => country.countryId === contryIdInt).hasStates){
                getStates(countryId)
        }
    }

    function onRelationshipChange(rs){
        setValue("relationship", rs);
    }

    return (
        <>
            <Row>
                <Col className="col-12 col-lg-4">
                    <CdsInputField
                        label="First Name"
                        required={true}
                        showTooltip={false}
                        name="firstName"
                        type="text"
                        placeholder=""
                    />
                </Col>
                <Col className="col-12 col-lg-4">
                    <CdsInputField
                        label="Last Name"
                        required={true}
                        showTooltip={false}
                        name="lastName"
                        type="text"
                        placeholder=""
                    />
                </Col>
                <Col className="col-12 col-lg-4">
                    <CdsDropdownField
                        label="Relationship"
                        required={true}
                        name="relationship"
                        allowMultiple={false}
                        options={relationships}
                        optionTextField={"label"}
                        optionValueField={"label"}
                        onChange={(evt)=> onRelationshipChange(evt.target.value)}
                    />
                </Col>
            </Row>
            <PhoneControl international={data?.postalCode?.startsWith("+")}/>
            <Row>
                <Col className="col-12 col-lg-6">
                    <CdsDropdownField
                        label="Country"
                        name={`country`}
                        key={`country`}
                        options={countries}
                        required={false}
                        optionValueField="countryCode"
                        optionTextField="name"
                        onChange={(evt) =>
                            onCountryChanged(evt.target.value)
                        }
                    />            
                </Col>
            </Row>
            <Row>
                <Col className="col-12 col-lg-6">
                    <CdsInputField
                        label="Address Line 1"
                        required={false}
                        showTooltip={false}
                        name="address1"
                        type="text"
                        placeholder=""
                    />            
                </Col>
            </Row>
            <Row>
                <Col className="col-12 col-lg-6">
                    <CdsInputField
                        label="Address Line 2"
                        required={false}
                        showTooltip={false}
                        name="address2"
                        type="text"
                        placeholder=""
                    />            
                </Col>
            </Row>
            <Row>
                <Col className="col-6 col-lg-4">
                    <CdsInputField
                        label="City"
                        required={false}
                        showTooltip={false}
                        name="city"
                        type="text"
                        placeholder=""
                    />            
                </Col>
                <Col className="col-6 col-lg-4">
                    <CdsDropdownField
                        label="State"
                        name={`state`}
                        key={`state`}
                        options={selectedStates}
                        required={false}
                        optionValueField="stateAbrv"
                        optionTextField="name"
                        disabled={!(Array.isArray(selectedStates) && selectedStates.length > 0)}
                />
                </Col>
                <Col className="col-6 col-lg-4">
                    <CdsInputField
                        label="Postal Code"
                        required={false}
                        showTooltip={false}
                        name="postalCode"
                        type="text"
                        placeholder=""
                    />            
                </Col>
            </Row>
        </>
    );
};

export default ContactModalForm;
